"use client"

import { ComponentConfig } from "@measured/puck"
import Image from "next/image"
import { ADMIN_API_CONFIG } from "../../../../../../constants/api-configs"
import { DefaultImage } from "../../../../../../lib/external-components"
import { CardServiceProps } from "./index"

export const RenderConfig: ComponentConfig<CardServiceProps> = {
  render: ({ items, className }: CardServiceProps) => {
    return (
      <div>
        {items?.map((item, index) => (
          <a
            href={item.link}
            key={index}
            className="w-full sm:py-[64px] py-[32px] flex items-center group/item relative border-b border-[#FFFFFF80]"
          >
            <div className="relative flex items-center">
              <div className="absolute left-0 sm:w-[149px] sm:h-[109px] w-[80px] h-[60px] opacity-0 group-hover/item:opacity-100 transition-opacity duration-300 z-10">
                <Image
                  src={item.image ? `${ADMIN_API_CONFIG.API_URL}${item.image}` : DefaultImage}
                  alt={item.title}
                  className="w-full h-full rounded-xl object-cover"
                  fill
                />
              </div>

              <div className="z-10 sm:text-3.5xl text-xl sm:leading-[44px] leading-[32px] font-semibold text-white text-left transform sm:group-hover/item:translate-x-[182px] group-hover/item:translate-x-[100px] transition-transform duration-1000">
                <p>{item.title}</p>
              </div>
            </div>
          </a>
        ))}
      </div>
    )
  },
}
